module.exports = __webpack_public_path__ + "img/done.7c64f84e.png";